const xogAfterGetData = async (id, data) => {
  // Array of IDs that should just return data without modification
  // Add all the IDs you want to exempt here
  const exemptIds = ["62", "65"];

  if (exemptIds.includes(id)) return data;
  
  const g62Data = await fetch (`https://cdn.xotiny.com/assets/shop/gurvj2-ws/62.json?${xoUpdate}`)
  const g62DataJson = await g62Data.json();
  g62DataJson.images = data.images;
  g62DataJson.filter = data.filter;
  g62DataJson.title = data.title;
  g62DataJson.description = data.description;
  Object.keys(data).forEach(key => {
    data[key] = g62DataJson[key];
  });
  return data;
}
